module.exports = __webpack_public_path__ + "static/media/affiliate-tutorial-step-3.dd8c284c.webp";